import Vue from 'vue';
import Vuex from 'vuex';
import store from 'store';
import { differenceInDays, format, addDays } from 'date-fns';
import { convertToTimeZone } from 'date-fns-timezone';
import { sleep } from '@/mixins/common'
import { toggleFixedBody } from '@/mixins/common'

Vue.use(Vuex);

const data = store.get('himekuri');
let diffInDays = (data && data.lastAnswerDate)
  ? differenceInDays(new Date(), new Date(data.lastAnswerDate))
  : 0;

export default new Vuex.Store({
  state: {
    circles: [
      { x:  21, y:  45, w: 70, h: 75 },
      { x: 103, y:  80, w: 54, h: 55 },
      { x: 167, y:  74, w: 50, h: 55 },
      { x: 231, y:  85, w: 50, h: 50 },
      { x: 298, y:  42, w: 71, h: 78 }, // 5
      { x: 317, y: 141, w: 50, h: 50 },
      { x: 252, y: 156, w: 50, h: 50 },
      { x: 176, y: 138, w: 50, h: 50 },
      { x: 104, y: 153, w: 50, h: 50 },
      { x:   9, y: 133, w: 71, h: 76 }, // 10
      { x:  10, y: 217, w: 50, h: 50 },
      { x:  81, y: 218, w: 50, h: 50 },
      { x: 152, y: 204, w: 50, h: 50 },
      { x: 220, y: 210, w: 50, h: 50 },
      { x: 294, y: 192, w: 70, h: 76 }, // 15
      { x: 313, y: 281, w: 50, h: 50 },
      { x: 245, y: 278, w: 50, h: 50 },
      { x: 179, y: 270, w: 50, h: 50 },
      { x: 106, y: 285, w: 50, h: 50 },
      { x:  11, y: 272, w: 84, h: 77 }, // 20
    ],
    answeredIds: (data) ? data.answeredIds: [],
    checkpointId: 0,
    currentQuestionCount: (data) ? (data.answeredIds.length < 24 ? data.answeredIds.length + 1 : data.answeredIds.length) : 1,
    currentQuestionId: (data) ? data.currentQuestionId : 0,
    todaysQuestionNum: (data && diffInDays < 1) ? data.todaysAnswerNum + 1 : 1,
    todaysAnswerNum: (data && diffInDays < 1) ? data.todaysAnswerNum : 0,
    lastAnswerDate: (data) ? data.lastAnswerDate: '',
    diffInDays: diffInDays,
    isShownModalIntro: false,
    isShownModalCheckpoint: false,
    isShownModalStamp: false,
    isShownModalRegulation: false,
    isShownAnsweredArea: (data) ? !(data.answeredIds.length < 24) : 0,
    isLimited: differenceInDays(new Date(), new Date(2020, 2, 9, 0, 0)) < 0,
    isAnswered: false,
  },
  mutations: {
    addAnsweredId(state, id) {
      state.answeredIds.push(id);
    },
    addCurrentQuestionCount(state) {
      if (state.currentQuestionCount < 24) {
        state.currentQuestionCount++;
      }
    },
    addTodaysQuestionNum(state) {
      state.todaysQuestionNum++;
    },
    addTodaysAnswerNum(state) {
      state.todaysAnswerNum++;
    },
    toggleModalIntro(state, bool) {
      state.isShownModalIntro = bool;
      toggleFixedBody(bool);
    },
    toggleAnswered(state, bool) {
      state.isAnswered = bool;
    },
    openModalCheckpoint(state, id) {
      state.checkpointId = id;
      state.isShownModalCheckpoint = true;
      toggleFixedBody(true);
    },
    closeModalCheckpoint(state) {
      state.isShownModalCheckpoint = false;
      toggleFixedBody(false);
    },
    OpenAnsweredArea(state) {
      state.isShownAnsweredArea = true;
    },
    toggleModalStamp(state, bool) {
      state.isShownModalStamp = bool;
      toggleFixedBody(bool);
    },
    toggleModalRegulation(state, bool) {
      state.isShownModalRegulation = bool;
      toggleFixedBody(bool);
    },
    addLastAnswerDate(state) {
      const date = new Date(new Date().setHours(0, 0, 0, 0));
      const timeZone = "Asia/Tokyo";
      state.lastAnswerDate = convertToTimeZone(date, {timeZone: timeZone});
    },
    setCurrentQuestionId(state, id) {
      state.currentQuestionId = id;
    },
    saveData(state) {
      const {
        answeredIds,
        todaysAnswerNum,
        lastAnswerDate,
      } = state;

      store.set('himekuri', {
        answeredIds,
        todaysAnswerNum,
        lastAnswerDate,
      });
    },
    testDate7th(state) {
      const date = new Date(new Date().setHours(0, 0, 0, 0));
      const timeZone = "Asia/Tokyo";
      state.lastAnswerDate = convertToTimeZone(addDays(date, -3), {timeZone: timeZone});
    },
  },
  actions: {
    async openModalStamp(context) {
      let checkPoints = [0, 1, 2, 4, 9, 14, 19];
      let answersNum = this.state.answeredIds.length - 1;
      await sleep(2000);
      requestAnimationFrame(async () => {
        // スタンプ部分までスクロール
        window.scrollTo(0, 0);
        // スタンプアニメーション
        context.commit('toggleModalStamp', true);
        await sleep(1270 + 870);
        context.commit('toggleModalStamp', false);
        // チェックポイントの場合はモーダルを表示
        let checkPointIndex = checkPoints.indexOf(answersNum);
        if(!(checkPointIndex < 0)) {
          await sleep(1400);
          context.commit('openModalCheckpoint', checkPointIndex);
        }
      });
    },
    doSave({commit}) {
      commit('saveData')
    }
  },
  modules: {
  }
})
